var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReposted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 22.667H9.83333V18.667L4.5 24.0003L9.83333 29.3337V25.3337H25.8333V17.3337H23.1667M9.83333 9.33366H23.1667V13.3337L28.5 8.00033L23.1667 2.66699V6.66699H7.16667V14.667H9.83333V9.33366Z",
    fill: "#CBA301"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReposted);
export default __webpack_public_path__ + "static/media/Reposted.f57afdc76cbdcb954adc4d9305172107.svg";
export { ForwardRef as ReactComponent };